<template>
	<v-container fluid class="mt-4 ml-2 pr-6">
    <!--  -->
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title class="text-subtitle-1">
	  		    Requisiciones
	  		    <v-spacer></v-spacer>

            <!-- Boton para descargar el excel -->
              <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( nomina, 'Requisiciones')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              class="mr-2"
              small
              color="primary"
              dark
              :disabled="!requisicionesNuevasSeleccionadas.length || cargar"
              @click="preAutorizarMasivo()"
              tile
            >
              <v-icon small left>mdi-check-decagram</v-icon>
              Preautorizar
              <span v-if="requisicionesNuevasSeleccionadas.length">
                ({{ requisicionesNuevasSeleccionadas.length }})
              </span>
            </v-btn>

            <v-btn
              class="mr-2"
              small
              color="brown"
              dark
              tile
              v-if="puedeMetodoPago"
              :disabled="!requisicionesPreAutorizadasSeleccionadas.length || cargar"
              @click="abrirMetodoPagoMasivo()"
            >
              <v-icon small left>mdi-cash-multiple</v-icon>
              Método de pago
              <span v-if="requisicionesPreAutorizadasSeleccionadas.length">
                ({{ requisicionesPreAutorizadasSeleccionadas.length }})
              </span>
            </v-btn>

            <v-btn 
              color="primary" 
              @click="initialize()" 
              small 
              tile
            >
              <v-icon small left>mdi-refresh</v-icon>
              Consultar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row>
	  		  		<v-col cols="12" md="4" lg="2" class="pb-0">
                <label>Selecciona un ciclo</label>
                <v-autocomplete
                  label="Ciclo"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="ciclo"
                  :items="ciclos"
                  item-text="ciclo"
                  item-value="ciclo"
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3" >
                <label>Fecha inicio</label>
                <v-text-field
                  filled
                  single-line
                  label="Fecha inicio"
                  type="date"
                  hide-details
                  v-model="fecha_inicio"
                  dense
                  @keyup.enter="initialize()"
                  clearable
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3" >
                <label>Fecha final</label>
                <v-text-field
                  filled
                  single-line
                  label="Fecha final"
                  type="date"
                  hide-details
                  v-model="fecha_final"
                  dense
                  @keyup.enter="initialize()"
                  clearable
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="4" lg="2" class="pb-0">
                <label>Estatus</label>
                <v-select
                  label="Estatus"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="estatus"
                  :items="['Nueva','Pre Autorizada','Procesada']"
                  clearable
                ></v-select>
              </v-col>
	  		  	</v-row>

            <v-row justify="end">

              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  filled
                  single-line
                  label="Búscar"
                  append-icon="mdi-magnify"
                  hide-details
                  v-model="buscar"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>


            <!-- REQUISICIONES -->
					  <v-data-table
					    :headers="headers"
					    :items="filterNomina"
					    dense
              :search="buscar"
					    class="elevation-0 mt-4"
              show-select
              v-model="nominaSelected"
              item-key="id"
              :item-disabled="esRequisicionNoSeleccionable"
					  >

              <!-- Monto con formato -->
              <template v-slot:item.total="{ item }">
                <span>{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.total ) }}</span>
              </template>

              <template v-slot:item.descripcion="{ item }">
                <v-chip color="grey"   small dark v-if="item.descripcion == 'Nueva'">Nueva</v-chip>
                <v-chip color="orange" small dark v-if="item.descripcion == 'Pre Autorizada'">Pre Autorizada</v-chip>
                <v-chip color="blue"   small dark v-if="item.descripcion == 'Pendiente'">Pendiente</v-chip>
                <v-chip color="green"  small dark v-if="item.descripcion == 'Autorizada'">Autorizada</v-chip>
                <v-chip color="black"  small dark v-if="item.descripcion == 'Rechazada'">Rechazada</v-chip>
                <v-chip color="green"  small dark v-if="item.descripcion == 'Aceptada'">Aceptada</v-chip>
                <v-chip color="green" small dark v-if="item.descripcion == 'Procesada'">Procesada</v-chip>
              </template>

					    <template v-slot:item.actions="{ item }">
					      <v-icon
					        small
					        class="mr-2"
					        color="blue"
					        @click="editItem(item)"
					      >
					        mdi-eye
					      </v-icon>
					    </template>
					  </v-data-table>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

    <!-- Dialgo para editar o ver la requisición -->
	  <v-dialog
      v-model="dialog"
      max-width="1400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h6">Folio: {{ editedItem.id }}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            rounded
            small
            icon
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="black--text" v-if="editedIndex >= 0">
        	<span><b>Solicitante: </b> {{ editedItem.nombre_completo }}</span>
        	<br/>
          <b>Estatus: </b> 
          <span>
            <v-chip color="grey"   small dark v-if="editedItem.descripcion == 'Nueva'">Nueva</v-chip>
            <v-chip color="orange" small dark v-if="editedItem.descripcion == 'Pre Autorizada'">Pre Autorizada</v-chip>
            <v-chip color="blue"   small dark v-if="editedItem.descripcion == 'Pendiente'">Pendiente</v-chip>
            <v-chip color="green"  small dark v-if="editedItem.descripcion == 'Autorizada'">Autorizada</v-chip>
            <v-chip color="black"  small dark v-if="editedItem.descripcion == 'Rechazada'">Rechazada</v-chip>
            <v-chip color="green"  small dark v-if="editedItem.descripcion == 'Aceptada'">Aceptada</v-chip>
            <v-chip color="green"  small dark v-if="editedItem.descripcion == 'Procesada'">Procesada</v-chip>
          </span>
          <br/>
          <br/>

          <v-col cols="12" v-if="editedItem.proveedor">
            <v-card class="shadowCard">
              <v-card-title class="text-subtitle-1">
                Proveedor
              </v-card-title>
              <v-card-text class="black--text">
                <b>Nombre Comercial:</b> {{ editedItem.proveedor.nombre_comercial }}<br/>
                <b>Titular:</b> {{ editedItem.proveedor.titular }}<br/>
                <b>Dirección:</b> {{ editedItem.proveedor.direccion }}<br/>
                <b>Teléfono:</b> {{ editedItem.proveedor.telefono }}<br/>
                <b>Clabe:</b> {{ editedItem.proveedor.clabe }}<br/>
                <b>Banco:</b> {{ editedItem.proveedor.banco }}<br/>
                <b>Vendedor:</b> {{ editedItem.proveedor.vendedor }}<br/>
                <b>Tipo insumos:</b> {{ editedItem.proveedor.tipo_insumos }}<br/>
              </v-card-text>
            </v-card>
          </v-col>

          <v-row>
            <v-col cols="12" md="4" lg="3" v-for="(img, i) in editedItem.fotos" :key="i">
              <v-card class="py-4 shadowCard" v-if="img.extension != 'pdf'" @click="verImagen2( img )">
                <v-img :src="url_servidor + img.name" contain aspect-ratio="2"></v-img>
              </v-card>
              <v-card class="py-4 shadowCard" v-if="img.extension == 'pdf'" @click="verImagen2( img )">
                <embed :src="url_servidor + img.name"  type="application/pdf">
              </v-card>              
            </v-col>
          </v-row>

        	<v-row>

            <!-- DESCAR EL EXCEL -->
						<v-col cols="12">
        			<v-btn 
	              class="mr-2" 
	              small dark color="green"
	              @click="exportar()">
	              <v-icon>mdi-microsoft-excel</v-icon>
	            </v-btn>

              <v-btn 
                small 
                color="brown"
                dark      
                v-if="['Pre Autorizada'].includes(editedItem.descripcion) && puedeMetodoPago"    
                :disabled="!requisicionesSelected.length"    
                @click="abrirMetodoPagoIndividual()"
              >
                Metodo de Pago
              </v-btn> 
        		</v-col>

            <!-- Tabla de requisiciones -->
        		<v-col cols="12">
        			<v-data-table
						    :headers="headersDetalle"
						    :items="editedItem.detalle"
						    class="elevation-0"
						    dense
                show-select
                v-model="requisicionesSelected"
                item-key="id"
                :item-disabled="esPartidaNoSeleccionable"
						  >

                <!-- Monto con formato -->
						  	<template v-slot:item.costo_total="{ item }">
						      <span>{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.costo_total ) }}</span>
						    </template>

                <template v-slot:item.fecha_propuesta="{ item }">
                  <span>{{ item.fecha_propuesta ? String(item.fecha_propuesta).slice(0, 10) : '—' }}</span>
                </template>

                <template v-slot:item.cotizacion_sn="{ item }">
                  <span v-for="(foto, i) in item.fotos" :key="i">
                    <v-icon 
                      color="primary" 
                      @click="verImagen( foto.name )"
                      v-if="extensionImagenes.includes( foto.extension )"
                    >
                      mdi-file-image
                    </v-icon>
                  </span>
                </template>

                <template v-slot:item.imagen_pago="{ item }">
                  <span v-for="(foto, i) in item.fotosPago" :key="i">
                    <v-icon 
                      color="primary" 
                      @click="verImagen( foto.name )"
                      v-if="extensionImagenes.includes( foto.extension )"
                    >
                      mdi-file-image
                    </v-icon>
                  </span>
                </template>

                <!-- Acciones -->
						    <template v-slot:item.estatus="{ item }">    
                   <v-chip color="grey"    small dark v-if="item.estatus == 0">Nueva</v-chip>
                   <v-chip color="green"   small dark v-if="item.estatus == 1">Procesada</v-chip> 
                   <v-chip color="green"   small dark v-if="item.estatus == 3">Procesada</v-chip>
                   <v-chip color="black"   small dark v-if="item.estatus == 4">Rechazada</v-chip>
						    </template>

                <template v-slot:item.actions="{ item }">
                  <span v-if="item.activo_sn == 0">
                    <v-chip small color="red" dark>Eliminada</v-chip>
                  </span>
                  <!-- Eliminar -->
                  <v-tooltip bottom v-if="item.activo_sn == 1" color="red">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="item.activo_sn == 1"
                        :disabled="editedItem.descripcion == 'Procesada'"
                        small
                        color="red"
                        @click="eliminarRequisicion(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-close
                      </v-icon>
                    </template>
                    <span>¿Eliminar?</span>
                  </v-tooltip>
                </template>        
						  </v-data-table>
            </v-col>
        	</v-row>
        </v-card-text>

        <v-card-actions>
          <!-- <v-btn 
            small 
            color="secondary"
            dark
            v-if="['Nueva'].includes(editedItem.descripcion)"
            @click="preAutorizar( editedItem.descripcion )"
          >
            Rechazar
          </v-btn> -->
          <v-btn 
            small 
            color="primary"
            dark
            v-if="['Nueva'].includes(editedItem.descripcion)"
            :disabled="cargar"
            @click="preAutorizar()"
          >
            Preautorizar
            <span v-if="partidasParaPreautorizar.length">
              ({{ partidasParaPreautorizar.length }} partidas)
            </span>
          </v-btn>
          
          <v-btn 
            :disabled="!requisicionesSelected.length"
            small 
            color="red"
            dark
            v-if="['Nueva','Rechazada'].includes(editedItem.descripcion)"
            @click="rechazarRequi( editedItem.descripcion )"
          >
            Rechazar
          </v-btn>

          <!-- <v-btn 
            small 
            color="green"
            dark
            v-if="['Pendiente'].includes(editedItem.descripcion)"
            @click="updateEstatus( 6 )"
          >
            Aceptar
          </v-btn> -->

          <v-btn 
            small 
            color="black"
            dark
            v-if="['Pendiente'].includes(editedItem.descripcion)"
            @click="updateEstatus( 5 )"
          >
            Rechazar
          </v-btn>

          <v-spacer></v-spacer>
          <span class="text-h6">
            TOTAL: <!-- Monto con formato -->
            <span>{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( editedItem.total ) }}</span>
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Visualizar imagenes -->
    <v-dialog
      v-model="dialogImagen"
      max-width="600px"
    >
      <v-card class="elevation-0">
        <v-card-text>
          <!-- Imagen -->
          <v-col cols="12">
            <v-img
              :src="url_servidor + imagen"
              contain
              max-width="600"
              height="750"
            >
            </v-img>
          </v-col>
        </v-card-text>
        <!-- Guardar la información  -->
        <v-btn
          absolute
          right
          top
          color="grey"
          dark
          fab
          class="elevation-6 mt-8"
          @click="dialogImagen = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn
        >
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogTipoPago"
      max-width="350px"
    >
      <v-card>
        <v-card-title>
          Metodo de Pago
        	<v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            rounded
            small
            icon
            @click="dialogTipoPago = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="black--text">
        	<v-row>
        		<v-col cols="12">
			    		<v-autocomplete
			    		  label="Tipo de pago"
			          filled
			          dense
			          clearable
			          v-model="tipopago"
			          :items="[
                          { id_tipopago: 1 , tipopago: 'Tarjeta' },
                          { id_tipopago: 2 , tipopago: 'Transferencia/Deposito' },
                          { id_tipopago: 3 , tipopago: 'Efectivo'  }
                        ]"
			          persistent-hint
			          item-text="tipopago"
			          item-value="id_tipopago"
                @input="handleTipoPagoChange()"
			        >
			        </v-autocomplete>

              <v-autocomplete
			    		  label="Cuenta de procedencia"
			          filled
			          dense
			          clearable
			          v-model="cuentametodopago"
			          :items="cuentas"
			          persistent-hint
			          item-text="cuenta_completa"
			          item-value="idcuentas_escuela"
			        >
			        </v-autocomplete>
             

	    			</v-col>
        	</v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            block
            color="primary"
            :disabled="cargar"
            @click="tipospago()"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVer" max-width="600px" v-if="img" persistent :fullscreen="fullscreen">
      <v-card class="elevation-0">
        <v-card-text>
          <!-- Imagen -->
          <v-col cols="12">
            <v-card height="100%" class="elevation-0" align="center" outlined v-if="img.extension != 'pdf'">
              <v-img :src=" url_servidor + img.name" contain aspect-ratio="2" v-if="fullscreen"></v-img>

              <v-img :src=" url_servidor + img.name" contain aspect-ratio="2" max-width="800" v-else ></v-img>
            </v-card>

            <v-card v-else>
              <embed :src="url_servidor + img.name"  type="application/pdf">
            </v-card>
          </v-col>
        </v-card-text>
        <v-card-actions class="pt-0" >
          <v-spacer></v-spacer>
          <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
          <v-btn color="error" text class="mr-2" @click="fullscreen = true" v-if="!fullscreen">Zoom</v-btn>
          <v-btn color="error" text class="mr-2" @click="fullscreen = false" v-else>Sin, Zoom</v-btn>
          <!-- Guardar la información  -->
          <v-btn
            color="primary" 
            dark 
            class="elevation-6" 
            @click="dialogVer = false"
          >Okey</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import funcionesExcel  from '@/mixins/funcionesExcel'


  const formatter = new Intl.NumberFormat('en-US', {
	  style: 'currency',
	  currency: 'USD',
	});

  export default {

  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      mostrarBoton: false,

      dialog: false,
      dialogDelete: false,
      dialogTipoPago: false,
      modoPagoMasivo: false,

      headers: [
        { text: 'ID'          , value: 'id', sortable: false },
        { text: 'Usuario'     , value: 'nombre_completo' },
        { text: 'Ciclo'       , value: 'ciclo' },
        { text: 'Motivo'      , value: 'comentarios' },
        { text: 'Proyecto'    , value: 'proyecto' },
        { text: 'Estatus'     , value: 'descripcion' },
        { text: 'Fecha'       , value: 'fecha_alta' },
        { text: 'Total'       , value: 'total' },
        { text: 'Actions'     , value: 'actions', sortable: false },
      ],

      headersDetalle: [
        { text: 'ID'           , value: 'id', sortable: false },
        { text: 'Elemento'     , value: 'elemento_mantenimiento' },
        { text: 'Tipo Requi'   , value: 'tipo_requisicion'       },
        { text: 'Temporalidad' , value: 'temporalidad'           },
        { text: 'Concepto'     , value: 'concepto'       },
        { text: 'Fecha propuesta', value: 'fecha_propuesta' },
        { text: 'Plantel'      , value: 'plantel'        },
        { text: 'Proyecto'     , value: 'proyecto'       },
        { text: 'Cantidad'     , value: 'cantidad'       },
        { text: 'Costo Unit.'  , value: 'costo_unitario' },
        { text: 'Total'        , value: 'costo_total'    },
        { text: 'Estatus'      , value: 'estatus',       },
        { text: 'Eliminar'     , value: 'actions',       },
        // { text: 'Pago'         , value: 'imagen_pago'    },
        // { text: 'Actions'      , value: 'actions', sortable: false },
      ],

      requisicionesSelected:[],
      nominaSelected: [],

      nomina: [],
      opVisualizacion: 1,

      editedIndex: -1,

      editedItem: {
        id: '',
        nombre_completo: '',
        detalles: [],
      },

      defaultItem: {
        idsolicitud_nomina: '',
        id_usuario: 0,
        idareas_ticket: 0,
      },

      file: '',
      dragging: false,
      vistaPrevia: null,
      autorizar:null,
      nota_rechazo:'',
      url:'',
      timerId:0,

      fecha_inicio: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fecha_final: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			buscar:'',

			dialogNuevaNomina:{
				estatus: false
			},

      dialogSubirComprobante: false,
      archivos:null,
      dialogImagen:false,
      url_servidor: '',
      imagen:'',
      extensionImagenes: ['BMP', 'GIF', 'jpg', 'jpeg', 'png', 'webp'],
      total:0,
      tipo_pago:0,
      tipopago: '',
      cuentametodopago: '',
      efectivometodopago: '',
      showCuentaMetodoPago: false,
      showEfectivo: false,
      url:'',
      dialogVer: false,
      fullscreen:false,
      img: null,
      ciclos   : [],
      ciclo    : null,
      estatus  : null,
      cuentas  :[]
    }),

    computed: {
    	...mapGetters('login', ['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

      filterNomina(){
        let data = this.nomina
        
        if( this.ciclo ){
          data = data.filter( el => el.ciclo == this.ciclo )
        }

        if( this.estatus ){
          data = data.filter( el => el.descripcion == this.estatus )
        }


        return data
      },

      partidasParaPreautorizar() {
        if (!this.editedItem || !this.editedItem.detalle) {
          return []
        }
        return this.obtenerPartidasActivas(
          this.editedItem.detalle,
          this.requisicionesSelected
        )
      },

      puedeMetodoPago() {
        var usuario = this.getdatosUsuarioERPERP
        if (!usuario) {
          return false
        }
        return [28, 334].indexOf(usuario.iderp) !== -1
      },

      requisicionesNuevasSeleccionadas() {
        return (this.nominaSelected || []).filter(function (item) {
          return item.descripcion === 'Nueva'
        })
      },

      requisicionesPreAutorizadasSeleccionadas() {
        return (this.nominaSelected || []).filter(function (item) {
          return item.descripcion === 'Pre Autorizada'
        })
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      dialogTipoPago(val) {
        if (!val) {
          this.modoPagoMasivo = false
        }
      },
      "dialogNuevaNomina.estatus"(val){
        if (!val){
          this.initialize()
        }
      }
    },

    created () {
      this.getCuentas()

      const partes = this.fecha_inicio.split('-') 
      this.fecha_inicio = partes[0] + '-' + partes[1] + '-01'

      this.url = axios.defaults.baseURL + 'justificantes/'
      this.url_servidor = axios.defaults.baseURL + 'fotos-egresos/'

      this.initialize()
      this.getCiclos()

    },

    methods: {

      getCuentas( ){
        this.cargar = true
        this.cuentas = []
        return this.$http.get('admin.cuentas.list').then(response=>{
          this.cuentas = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      initialize () {
        this.nomina = []
        this.cargar = true

        const payload = {
        	fecha_inicio: this.fecha_inicio,
        	fecha_final : this.fecha_final,
          ciclo       : this.ciclo
        }

        return this.$http.post('consultar.requisiciones', payload).then(response=>{
        	this.nomina = response.data

          if (Number(this.getdatosUsuarioERPERP.iderp) === 966) {
            this.nomina = this.nomina.filter(function (item) {
              return item && String(item.comentarios || '').trim() === 'Nómina Teachers'
            })
          }

        	this.cargar = false

          // Validar si ya hay información, para poder subir el comprobante o mostrarlos
          if( this.editedIndex > -1 ){
            const nomina = this.nomina.find( el => el.id == this.editedItem.id )

            this.editedItem = nomina
          }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getCiclos () {
        this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
          this.ciclos = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.nomina.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.requisicionesSelected = []
        this.dialog = true
      },

      esRequisicionNoSeleccionable(item) {
        return (
          item.descripcion !== 'Nueva' &&
          item.descripcion !== 'Pre Autorizada'
        )
      },

      esPartidaNoSeleccionable(item) {
        return item.activo_sn == 0
      },

      obtenerPartidasPendientesPago(detalle) {
        var lista = detalle || []
        return lista.filter(function (p) {
          return p.activo_sn == 1 && (p.estatus == 0 || p.estatus === '0')
        })
      },

      abrirMetodoPagoMasivo() {
        if (!this.requisicionesPreAutorizadasSeleccionadas.length) {
          return this.validarErrorDirecto(
            'Selecciona al menos una requisición Pre Autorizada'
          )
        }
        this.modoPagoMasivo = true
        this.dialogTipoPago = true
      },

      abrirMetodoPagoIndividual() {
        this.modoPagoMasivo = false
        this.dialogTipoPago = true
      },

      obtenerPartidasActivas(detalle, seleccionadas) {
        var lista = detalle || []
        var activas = lista.filter(function (p) {
          return p.activo_sn == 1
        })
        if (seleccionadas && seleccionadas.length) {
          var ids = seleccionadas.map(function (p) {
            return p.id
          })
          return activas.filter(function (p) {
            return ids.indexOf(p.id) !== -1
          })
        }
        return activas
      },

      ejecutarPreautorizarRequisicion(idRequisicion, idsPartidas) {
        var payload = {
          id_usuario_autoriza_rechaza: this.getdatosUsuarioERPERP.iderp,
          id_requisicion_compra_estatus: 5,
          id_requisicion: idRequisicion,
          ids: idsPartidas || [],
        }
        return this.$http.post('requisicion.preautorizar', payload)
      },

      close () {
      	this.autorizar = null
        this.requisicionesSelected = []
      	this.nota_rechazo = ''
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      exportar( ){
      	this.exportExcel( this.editedItem.detalles, 'excel_nomina')
      },

      grabarDatos( ){
        
        var formData = new FormData();

        const ids = this.requisicionesSelected.map(( registro ) => { return registro.id })
        
        formData.append("file"              , this.file );
        formData.append("requi"             , ids );
        formData.append("id_usuario_subio"  , this.getdatosUsuarioERPERP.iderp );
        formData.append("tipo_pago"         , this.tipo_pago );

        this.cargar = true

        return this.$http.post('subir.archivos.requi', formData).then(response=>{
          this.validarSuccess( response.data.message )
          this.file                   = null
          this.requisicionesSelected  = []
          this.vistaPrevia            = null
          this.cargar                 = false
          this.dialogSubirComprobante = false
          this.initialize( )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      verImagen( imagen ){
        this.imagen       = imagen
        this.img          = imagen
        this.dialogImagen = true
      },

      verImagen2( imagen ){
        this.img = imagen
        this.dialogVer = true
      },

      eliminarRequisicion( value ){
        this.cargar = true
        return this.$http.put('eleminar.partida/' + value.id ).then(response=>{
          this.validarSuccess( response.data.message )
          this.cargar                 = false
          this.initialize( )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      preAutorizarMasivo() {
        var self = this
        if (!this.nominaSelected.length) {
          return this.validarErrorDirecto('Selecciona al menos una requisición')
        }

        var nuevas = this.nominaSelected.filter(function (item) {
          return item.descripcion === 'Nueva'
        })

        if (!nuevas.length) {
          return this.validarErrorDirecto(
            'Solo puedes preautorizar requisiciones con estatus Nueva'
          )
        }

        this.cargar = true

        var promesas = nuevas.map(function (item) {
          var idsPartidas = (item.detalle || [])
            .filter(function (p) {
              return p.activo_sn == 1
            })
            .map(function (p) {
              return p.id
            })
          return self.ejecutarPreautorizarRequisicion(item.id, idsPartidas)
        })

        return Promise.all(promesas)
          .then(function (responses) {
            var totalPartidas = nuevas.reduce(function (sum, item) {
              var detalle = item.detalle || []
              return (
                sum +
                detalle.filter(function (p) {
                  return p.activo_sn == 1
                }).length
              )
            }, 0)
            var msg =
              responses[0] && responses[0].data
                ? responses[0].data.message
                : 'Requisición actualizada correctamente'
            self.validarSuccess(
              msg +
                ' — ' +
                nuevas.length +
                ' requisición(es)' +
                (totalPartidas
                  ? ', ' + totalPartidas + ' partidas'
                  : '')
            )
            self.nominaSelected = []
            self.initialize()
          })
          .catch(function (error) {
            self.validarError(
              error.response && error.response.data
                ? error.response.data
                : error
            )
          })
          .finally(function () {
            self.cargar = false
          })
      },

      preAutorizar() {
        var self = this
        if (!this.editedItem || !this.editedItem.id) {
          return this.validarErrorDirecto('No hay requisición seleccionada')
        }

        if (this.editedItem.descripcion !== 'Nueva') {
          return this.validarErrorDirecto(
            'Solo puedes preautorizar requisiciones con estatus Nueva'
          )
        }

        var partidas = this.partidasParaPreautorizar
        if (!partidas.length) {
          return this.validarErrorDirecto(
            'No hay partidas activas para preautorizar'
          )
        }

        this.cargar = true

        var idsPartidas = partidas.map(function (p) {
          return p.id
        })

        return this.ejecutarPreautorizarRequisicion(this.editedItem.id, idsPartidas)
          .then(function (response) {
            self.validarSuccess(
              response.data.message +
                ' (' +
                partidas.length +
                ' partida(s))'
            )
            self.requisicionesSelected = []
            setTimeout(function () {
              self.close()
            }, 1500)
            self.initialize()
          })
          .catch(function (error) {
            self.validarError(
              error.response && error.response.data
                ? error.response.data
                : error
            )
          })
          .finally(function () {
            self.cargar = false
          })
      },

      rechazarRequi( estatus ){
      this.cargar = true

      const payload = {
        id_usuario_autoriza_rechaza  : this.getdatosUsuarioERPERP.iderp,
        id_requisicion_compra_estatus: 4,
        id_requisicion: this.editedItem.id
      }

       const ids = this.requisicionesSelected.map((index)=>{ return index.id});
       const payload2 = {
        id  : ids,
      }

      return this.$http.post('requisicion.preautorizar', payload )
       .then(response=>{
         this.$http.post('update.rechazar.partida.requi', payload2 )
           .then(response=>{
            this.validarSuccess( response.data.message )
            this.requisicionesSelected = []     
            setTimeout(() => {
              this.close()
            }, 1500)
            this.cargar = false
            this.initialize()
      }).catch(error =>{
        this.validarError( error.response.data.message )
      }).finally(() => { this.cargar = false })
      }).catch(error =>{
        this.validarError( error.response.data.message )
      }).finally(() => { this.cargar = false })
      },

       estatusProcesar( estatus ){
        this.cargar = true

        const payload = {
          id_usuario_autoriza_rechaza  : this.getdatosUsuarioERPERP.iderp,
          id_requisicion_compra_estatus: 6,
          id_requisicion: this.editedItem.id
        }

        return this.$http.post('requisicion.preautorizar', payload ).then(response=>{
          this.validarSuccess( response.data.message )
          this.cargar                 = false
          this.initialize( )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      updateEstatus( estatus ){
        this.cargar = true

        const payload = {
          id_requisicion_compra_estatus: estatus,
          id_requisicion: this.editedItem.id
        }

        return this.$http.post('update.estatus.requisicion', payload ).then(response=>{
          this.validarSuccess( response.data.message )
          this.cargar                 = false
          this.initialize( )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      tipospago(){
        if ((this.tipopago == 1 || this.tipopago == 2) && (this.cuentametodopago == '' || this.cuentametodopago == null) ) {
          return this.validarErrorDirecto("Favor de seleccionar una cuenta de procedencia");
        }

        if (!this.tipopago) {
          return this.validarErrorDirecto('Favor de seleccionar un tipo de pago')
        }

        if (this.tipopago == 3){
          this.cuentametodopago = this.efectivometodopago
        }

        if (this.modoPagoMasivo) {
          return this.tipospagoMasivo()
        }

        this.cargar = true

        const seleccionados = this.requisicionesSelected;
        const ids = seleccionados.map((index) => {
          return index.id;
        });

        const payload = {
         tipo_pago: this.tipopago,
         numero_cuenta: this.cuentametodopago,
         id: ids,
         id_usuario_autoriza_rechaza  : this.getdatosUsuarioERPERP.iderp,
         id_requisicion_compra_estatus: 7,
         id_requisicion: this.editedItem.id
        }

        return this.$http.post('egresos.mandar.egresos', payload ).then(response=>{
            this.validarSuccess( response.data.message )
            this.cargar = false
            this.dialogTipoPago = false
            this.modoPagoMasivo = false
            this.initialize( )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })

      },

      tipospagoMasivo() {
        var self = this
        var preAutorizadas = this.requisicionesPreAutorizadasSeleccionadas

        if (!preAutorizadas.length) {
          return this.validarErrorDirecto(
            'Selecciona al menos una requisición Pre Autorizada'
          )
        }

        var lotes = []
        for (var i = 0; i < preAutorizadas.length; i++) {
          var item = preAutorizadas[i]
          var idsPartidas = this.obtenerPartidasPendientesPago(item.detalle).map(
            function (p) {
              return p.id
            }
          )
          if (!idsPartidas.length) {
            return this.validarErrorDirecto(
              'La requisición ' +
                item.id +
                ' no tiene partidas pendientes de pago'
            )
          }
          lotes.push({
            id_requisicion: item.id,
            ids: idsPartidas,
          })
        }

        this.cargar = true

        var promesas = lotes.map(function (lote) {
          return self.$http.post('egresos.mandar.egresos', {
            tipo_pago: self.tipopago,
            numero_cuenta: self.cuentametodopago,
            id: lote.ids,
            id_usuario_autoriza_rechaza: self.getdatosUsuarioERPERP.iderp,
            id_requisicion_compra_estatus: 7,
            id_requisicion: lote.id_requisicion,
          })
        })

        return Promise.all(promesas)
          .then(function (responses) {
            var msg =
              responses[0] && responses[0].data
                ? responses[0].data.message
                : 'Requisición actualizada correctamente'
            self.validarSuccess(
              msg + ' — ' + lotes.length + ' requisición(es)'
            )
            self.nominaSelected = []
            self.dialogTipoPago = false
            self.modoPagoMasivo = false
            self.tipopago = ''
            self.cuentametodopago = ''
            self.efectivometodopago = ''
            self.initialize()
          })
          .catch(function (error) {
            self.validarError(
              error.response && error.response.data
                ? error.response.data
                : error
            )
          })
          .finally(function () {
            self.cargar = false
          })
      },

    handleTipoPagoChange() {
    if (this.tipopago === 1 || this.tipopago === 2) {
      this.showCuentaMetodoPago = true;
    } else {
      this.showCuentaMetodoPago = false;
      this.cuentametodopago = null; // Limpiar el valor del campo si no está visible
    }

    if (this.tipopago === 3) {
      this.showEfectivo = true;
    } else {
      this.showEfectivo = false;
      this.efectivometodopago = null; // Limpiar el valor del campo si no está visible
    }
    },

    },
  }
</script>
<style scoped>
  .dropZone {
    width: 100%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>